import * as React from 'react';
import { getCapturedAssets, moveTimeStreamAssetToPosition } from 'owa-timestream-store';
import { useProjectId, getAssetDescriptor, ASSUMED_ASSET_WIDTH } from 'owa-timestream-asset-sdk';
import { clearSelectedAssets, toggleAssetSelection } from '../viewstate';
import getNextAvailableAssetSpace from '../util/getNextAvailableAssetSpace';

export default function useAutoPlaceCapturedAssets() {
    const projectId = useProjectId();
    const capturedAssets = getCapturedAssets(projectId);

    React.useEffect(() => {
        if (!capturedAssets.length) {
            return;
        }

        clearSelectedAssets();
        const capturedIds = capturedAssets.map(([id, asset]) => id);

        let assetPlacementX = 0;
        let assetPlacementY = 0;
        for (let i = 0; i < capturedAssets.length; i++) {
            const assetInfo = capturedAssets[i];
            const assetDesc = getAssetDescriptor(assetInfo[1].type);
            if (!assetDesc) {
                continue;
            }

            const assetId = assetInfo[0];
            const assetProps = assetDesc.createEmptyAsset();
            const resizeConfig = assetDesc.assetResizeConfiguration?.(assetProps.payload);
            const assetWidth =
                assetProps.width || resizeConfig?.defaultWidth || ASSUMED_ASSET_WIDTH;

            if (i === 0) {
                // place first asset in next available space
                const availableSpace = getNextAvailableAssetSpace(assetDesc);
                if (availableSpace) {
                    const { x, y } = availableSpace;
                    moveTimeStreamAssetToPosition(projectId, assetId, x, y);
                    assetPlacementX = x + assetWidth;
                    assetPlacementY = y;
                }
            } else {
                // place proceeding assets around the previous asset
                moveTimeStreamAssetToPosition(projectId, assetId, assetPlacementX, assetPlacementY);
                assetPlacementX += assetWidth;
            }
        }

        capturedIds.forEach(id => {
            toggleAssetSelection(id);
        });
    }, [projectId, capturedAssets]);
}
